module.exports = __webpack_public_path__ + "img/icon-closing.830d1082.svg";